module.exports = __webpack_public_path__ + "img/v0plus.b345f658.svg";